module.exports = __webpack_public_path__ + "img/136.5.c927a3f1.png";